import React from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import { Collapse, IconButton, Typography } from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

const columns = [
    { id: 'genset_serial_number', label: 'Genset Serial Number'},
    { id: 'controller_name', label: 'Controller'},
    { id: 'email_address', label: 'Username (Email)'},
    { id: 'change_log_type', label: 'Change Log Type'},
    { id: 'change_log_subtype', label: 'Change Log Sub Type'},
    { id: 'timestamp', label: 'Timestamp'},
    { id: 'actions', label: 'Actions'}
];

const ChangeLogTable = ({rowsPerPage,page,handleChangePage,handleChangeRowsPerPage,changeLogsData}) => {
    const [open, setOpen] = React.useState({});
    const handleClick = (id) => {
        setOpen(prevState => ({...prevState, [id]: !prevState[id]}))
    };
    
    return (
        <Box>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                    {columns.map((column) => (
                        <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        >
                         { column.label }
                        </TableCell>
                    ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {changeLogsData?.data?.length > 0 ?  changeLogsData?.data
                    .map((row) => {
                        return (
                        <><TableRow role="checkbox" tabIndex={-1} key={row.code} sx={{ '& > *': { borderBottom: 'unset' } }}>
                                {columns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                        <TableCell key={column.id} align={column.align}>
                                            {column.format && typeof value === 'number'
                                                ? column.format(value)
                                                : column.id === 'actions' ?
                                                    <>
                                                        <IconButton
                                                            aria-label="expand row"
                                                            size="small"
                                                            onClick={() => handleClick(row.id) }
                                                        >
                                                            {open[row.id] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                                        </IconButton>
                                                    </>
                                                    : 
                                                    (column.id === 'change_log_type' ||  column.id === 'change_log_subtype') && value  ?  value.replace('_', ' ') : value
                                                }
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7} >
                                    <Collapse in={open[row.id]} timeout="auto" unmountOnExit>
                                        <Box sx={{ marginTop: 1, marginBottom: 2}}>
                                           <Typography color='#6E6B6B'>Log Description - {row.log_description}</Typography> 
                                        </Box>    
                                    </Collapse>
                                </TableCell>
                            </TableRow></>
                        );
                    }): <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
                </TableBody>
                </Table>
            </TableContainer>
            { changeLogsData.total > 0 ?  
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={changeLogsData.total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            : <></>}
            </Paper>
        </Box>
    )
}

export default ChangeLogTable